import { Reducer } from 'redux';
import { IAction } from '../types';
import { localKeyInfo } from '../config';
import LocalStore from '@/utils/store';

export interface KalaokInfoState {
  volume: number;
}

const LOCALKEY = localKeyInfo.kalaokInfo;
const localVoiceInfo = LocalStore.getValue<KalaokInfoState>(LOCALKEY) || {};

export const kalaokInfo: KalaokInfoState = {
  volume: 0,
  ...localVoiceInfo
};

export const setKalaokInfo: (payload: KalaokInfoState) => IAction<KalaokInfoState> = (payload: KalaokInfoState) => ({
  type: 'setKalaokInfo',
  payload
});

const kalaokInfoReducer: Reducer<KalaokInfoState, IAction<any>> = (state = kalaokInfo, action: IAction<any>) => {
  const { type, payload } = action;
  switch (type) {
    case 'setKalaokInfo':
      LocalStore.setValue(LOCALKEY, payload);
      return {
        ...payload
      };
    default:
      return state;
  }
};

export default kalaokInfoReducer;
